import Card from "@pathwright/ui/src/components/card/Card"
import { Card as CardT } from "@pathwright/ui/src/components/card/types"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import PropTypes from "prop-types"
import { FeatureAction, FeatureKey } from "../../api/generated"
import EnterpriseSSOFeatureBlock from "../auth/EnterpriseSSOFeatureBlock"
import PathwrightSignInFeatureBlock from "../auth/PathwrightSignInFeatureBlock"
import FeatureBlockList, { Container } from "../block/FeatureBlockList"

const ManageFeatures = ({ card }: { card: CardT }) => {
  const { t } = useTranslate()

  return (
    <Card card={card} title={t("Configure Features")} emphasis="secondary">
      <Container>
        <PathwrightSignInFeatureBlock />
      </Container>
      <FeatureBlockList
        key={FeatureAction.AuthLogin}
        featureAction={FeatureAction.AuthLogin}
        featureKeys={[
          FeatureKey.AuthLoginOptionGlobalSsoApple,
          FeatureKey.AuthLoginOptionGlobalSsoGoogle
        ]}
        showTagFeatureBlock={false}
      />
      <Container>
        <EnterpriseSSOFeatureBlock />
      </Container>
      <FeatureBlockList
        key={FeatureAction.View}
        featureAction={FeatureAction.View}
        featureKeys={[
          FeatureKey.CohortActivityFeed,
          FeatureKey.CohortMemberDirectory
        ]}
      />
    </Card>
  )
}

ManageFeatures.displayName = "ManageFeatures"

ManageFeatures.propTypes = {
  // provided by CardStack > CardStackCard
  card: PropTypes.object.isRequired
}

export default ManageFeatures
